"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/*@ngInject*/
exports.default = ['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('damaged', {
            url: '/damaged/:id',
            template: require('../views/damaged.html'),
            controller: 'DamagedController',
            controllerAs: 'damaged',
            params: {
                id: { squash: true, value: null }
            },
            resolve: {
                categories: ['api', function (api) {
                        return api.get('/b2b/damaged/categories')
                            .then(function (items) {
                            return items;
                        }, function (err) {
                            console.log(err);
                        });
                    }],
                products: ['$stateParams', 'api', function ($stateParams, api) {
                        if ($stateParams.id) {
                            return api.get('/b2b/damaged/' + $stateParams.id + '/products')
                                .then(function (items) {
                                return items;
                            }, function (err) {
                                console.log(err);
                            });
                        }
                        else {
                            return api.get('/b2b/damaged/products')
                                .then(function (items) {
                                return items;
                            }, function (err) {
                                console.log(err);
                            });
                        }
                    }],
                category: ['$stateParams', 'api', function ($stateParams, api) {
                        if ($stateParams.id) {
                            return api.get('/b2b/categories/' + $stateParams.id)
                                .then(function (item) {
                                return item;
                            }, function (err) {
                                console.log(err);
                            });
                        }
                        else {
                            return {};
                        }
                    }]
            }
        });
    }];



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/damaged/config/routes.js
// module id = 391
// module chunks = 0